import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "./assets/css/materialdesignicons.min.css";
import JobListOne from "./pages/job-list-one";
import JobDetailOne from "./pages/job-detail-one";
import AboutUs from "./pages/aboutus";
import ContactUs from "./pages/contactus";
import Error from "./pages/error";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<Navigate to="/jobs" />} />
        <Route path="/jobs" exact element={<JobListOne />} />
        <Route path="/job-detail/:id" element={<JobDetailOne />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="*" element={<Error />} />
        <Route path="/error" element={<Error />} />
      </Routes>
    </>
  );
}

export default App;
